import React, {Component} from "react";
import {uploadFile} from "../../api/doLogin";
import {toast} from "react-toastify";
import Dropzone from "react-dropzone";
import {Button} from "reactstrap";
import {createFile} from "../../util/dataHelpers";

export class ReplaceableImageWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filesLoading: false
    }
    this.defaultAcceptedMimes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
  }

  dropError(context, error) {
    //alert('Error');
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (acceptedFiles.length === 0) return;
    this.props.onUpload && this.props.onUpload();
    var self = this;
    this.setState({
      // dropzoneActive: false,
      filesLoading: true
    });
    //console.log(acceptedFiles);
    //console.log(rejectedFiles);
    let req = new FormData;
    acceptedFiles.forEach(file => {
      if (this.props.renameFilename) {
        file = createFile([file], this.props.renameFilename, {
          type: file.type,
        });
      }
      req.append('file', file);
    });
    this.props.appendFormData && this.props.appendFormData.forEach((data) => {
      req.append(data.name, data.value);
    })
    uploadFile(this.props.uploadURL, req)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          toast.success('File(s) Uploaded Successfully');
          // self.updateData();
          self.setState({
            filesLoading: false
          }, () => {
            this.props.onReplace && this.props.onReplace(data.data);
          });
        } else {
          toast.error("Error " + data.message);
          self.setState({
            filesLoading: false
          });
        }
      })
      .catch(error => {
        self.setState({
          filesLoading: false
        });
        console.error(error);
      })
      .finally(() => {
        self.props.onComplete && self.props.onComplete();
      });
  }

  onDragEnter() {
    // this.setState({
    //   dropzoneActive: true
    // });
  }

  onDragLeave() {
    // this.setState({
    //   dropzoneActive: false
    // });
  }

  render() {
    const {children, canReplace, uploadURL, maxSize} = this.props;
    if (!canReplace || !uploadURL) return children;
    return (
      <Dropzone style={{width: '100%', border: '0px dashed'}}
                accept={(this.props.acceptedMimes || this.defaultAcceptedMimes).join(", ")}
                disableClick
                onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
                maxSize={maxSize || 200 * 1024 * 1024}
                multiple={this.props.limit !== 1}
                onDragEnter={() => this.onDragEnter()}
                onDragLeave={() => this.onDragLeave()}>
        {({getRootProps, getInputProps, open}) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {children}
            <Button color="secondary"
                    style={{height: 30, margin: 0, padding: 0, borderRadius: 5}}
                    onClick={() => open()}>Replace...</Button>
            {this.state.filesLoading && (
              <div style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                paddingTop: 100,
                backgroundColor: "#fff",
                opacity: 0.5,
                top: 0,
                left: 0
              }}>
                <div className="sk-double-bounce" style={{opacity: 1}}>
                  <div className="sk-child sk-double-bounce1"></div>
                  <div className="sk-child sk-double-bounce2"></div>
                </div>
              </div>
            )}
          </div>
        )}
      </Dropzone>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Shared/ReplaceableImageWrapper.js